import styled from "styled-components"

const StyledTabPanels = styled.div`
  width: 100%;
  margin-top: 16px;
  max-width: 100%;
  box-sizing: border-box;
`

export default StyledTabPanels
